document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const blocks = document.querySelectorAll('.ambassador__blocks--item');
  if (!blocks.length) return;

  blocks.forEach(block => {
    const title = block.querySelector('.block__title');
    const text = block.querySelector('.block__text');
    const link = block.querySelector('.block__link a');

    // Animate entire block fade in from bottom
    gsap.fromTo(
      block,
      { y: 20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: block,
          start: "top 80%",
          toggleActions: "play reverse play reverse",
        }
      }
    );

    // Animate title from top
    if (title) {
      gsap.fromTo(
        title,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: title,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }

    // Animate text
    if (text) {
      gsap.fromTo(
        text,
        { y: 10, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.2,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: text,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }

    // Animate link scale-in
    if (link) {
      gsap.fromTo(
        link,
        { scale: 0.95, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          delay: 0.2,
          duration: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: link,
            start: "top 80%",
            toggleActions: "play reverse play reverse",
          }
        }
      );
    }
  });

  ScrollTrigger.refresh();
});
